export const currencyFormatter = (amount: number, currency: string): string => {
    // implementation
    if(amount === null || amount === undefined) return "Sikertelen adatbetöltés!";
    return amount
        .toLocaleString('en-Us', { style: 'currency', currency: currency })
        .replace(/\.\d{2}/, '')
        .replaceAll(',', ' ');
}